module.exports = __webpack_public_path__ + "img/ff2.b50d8c59.png";